/**
 * Invoice config — the company header + warranty terms + footer badge that print
 * on customer invoices. Editable in Settings → Invoices (org_setting key
 * 'invoice_config', admin-write via RLS). The print view + the editor share this
 * shape; missing keys fall back to the confirmed Sedgwick defaults below.
 */
import { useOrgSettingJson } from "@/lib/orgSettings";

export interface InvoiceConfig {
  name: string;
  tagline: string;
  addr1: string;
  addr2: string;
  phone: string;
  textPhone: string;
  email: string;
  web: string;
  pay: string;
  license: string;
  badge: string;
  warrantyPartsEquip: number;   // years — equipment parts
  warrantyPartsControl: number; // years — controls/thermostats
  warrantyLabor: number;        // years — Sedgwick install labor
}

export const INVOICE_CONFIG_KEY = "invoice_config";

export const INVOICE_CONFIG_DEFAULTS: InvoiceConfig = {
  name: "Sedgwick Heating & Air Conditioning",
  tagline: "Heating · Cooling · Plumbing",
  addr1: "1240 Trapp Road, Suite A",
  addr2: "Eagan, MN 55121",
  phone: "(952) 881-9000",
  textPhone: "(952) 592-9895",
  email: "contact@sedgwickheating.com",
  web: "sedgwickheating.com",
  pay: "sedgwickheating.com/pay",
  license: "Licensed · Bonded · Insured",
  badge: "PROUDLY LOCAL & INDEPENDENT • NOT PRIVATE EQUITY",
  warrantyPartsEquip: 10,
  warrantyPartsControl: 5,
  warrantyLabor: 2,
};

/** Always returns a full config: stored values merged over the defaults. */
export function useInvoiceConfig(): InvoiceConfig {
  const { data } = useOrgSettingJson<Partial<InvoiceConfig>>(INVOICE_CONFIG_KEY, {});
  return { ...INVOICE_CONFIG_DEFAULTS, ...(data ?? {}) };
}
